import type { EnTranslation } from './en';

/** Bahasa Melayu — same shape as `en`. */
export const ms: EnTranslation = {
  header: {
    brandAlt: 'Avatar',
    title: 'Sembang dengan Avatar',
    subtitle: 'Tanya, teroka, atau dapatkan bantuan serta-merta',
    reset: 'Set semula perbualan',
  },
  chat: {
    greeting: 'Helo, bagaimana saya boleh membantu?',
    typing: 'Avatar sedang menaip…',
    errorFallback: 'Sesuatu telah berlaku. Sila cuba lagi.',
    retry: 'Cuba lagi',
    streamingPlaceholder: '…',
  },
  input: {
    placeholder: 'Tanya apa sahaja...',
    ariaLabel: 'Mesej Avatar',
    send: 'Hantar mesej',
    poweredBy: 'Dikuasakan oleh Avatar.inc',
  },
  popular: {
    ariaLabel: 'Soalan dicadangkan',
    q1: 'Apakah Zetrix Avatar?',
    q2: 'Bagaimana saya mencipta avatar?',
    q3: 'Apa yang avatar saya boleh lakukan?',
    q4: 'Bagaimana saya bermula?',
  },
  doc: {
    title: 'Widget Avatar',
  },
};
